import { createFileRoute, redirect } from '@tanstack/react-router'
import { orgRoutes } from '@/lib/routes'

/**
 * There is no groups index screen — top-level groups are browsed on All QR
 * Codes. This route still gets linked (command palette, hand-edited URLs), so
 * it forwards there rather than 404ing.
 */
export const Route = createFileRoute('/o/$org/groups/')({
  beforeLoad: ({ params: { org } }) => {
    throw redirect({ ...orgRoutes(org).qrCodes })
  },
})
